import amplitude from 'amplitude-js';
var setUserIdAmplitude = function (profileToken) {
    amplitude.getInstance().setUserId(profileToken);
};
export default setUserIdAmplitude;
